import { FC } from 'react';
import { AuthForm } from 'entities/auth/ui/AuthForm/AuthForm';
import { useSignInMutation } from 'features/auth/api/userAuthApi';
import { FormDataType } from 'features/auth/types';

export const UserAuth: FC = () => {
  const [signInRequest] = useSignInMutation();

  const signIn = (formData: FormDataType) => {
    signInRequest(
      new URLSearchParams({
        username: formData.email,
        password: formData.password,
        scope: 'admin', // TODO поменять
      }),
    );
  };

  return <AuthForm onSubmitHandler={signIn} />;
};
